import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { PickList } from 'primereact/picklist';
import { BlockUI } from 'primereact/blockui';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useEffect, useState } from 'react';
import { obtieneUsuarios } from '../../services/Siniestro/SiniestroService';
import defaultApi from '../../api/defaultApi';

const obtenerTodosLosPuestos = async () => {
    const response = await defaultApi.get('/usuarioPuestoSiniestro/todosPuestos');
    return response.data;
};

const obtenerPuestosDeUsuario = async (usuarioId) => {
    const response = await defaultApi.get(`/usuarioPuestoSiniestro/porUsuario/${usuarioId}`);
    return response.data;
};

const guardarPuestosDeUsuario = async (usuarioId, lstPuestos) => {
    const response = await defaultApi.post(`/usuarioPuestoSiniestro/actualizarPorUsuario/${usuarioId}`, lstPuestos);
    return response.data;
};

const AsignaPuestosUsuario = ({ funcSalir, toast }) => {
    const [lstUsuarios, setLstUsuarios] = useState([]);
    const [usuarioSel, setUsuarioSel] = useState(null);
    const [cargandoUsuarios, setCargandoUsuarios] = useState(false);
    const [cargandoPuestos, setCargandoPuestos] = useState(false);
    const [procesando, setProcesando] = useState(false);

    const [origen, setOrigen] = useState([]);
    const [destino, setDestino] = useState([]);

    // Cargar usuarios al montar
    useEffect(() => {
        const carga = async () => {
            try {
                setCargandoUsuarios(true);
                const datos = await obtieneUsuarios();
                setLstUsuarios(datos);
            } catch (err) {
                console.error('Error cargando usuarios', err);
            } finally {
                setCargandoUsuarios(false);
            }
        };
        carga();
    }, []);

    // Cuando cambia el usuario, cargar sus puestos y todos los puestos disponibles
    useEffect(() => {
        if (!usuarioSel?.usuarioId) {
            setOrigen([]);
            setDestino([]);
            return;
        }

        const carga = async () => {
            try {
                setCargandoPuestos(true);

                // 1. Obtener todos los puestos del sistema con jerarquía completa
                const todosRaw = await obtenerTodosLosPuestos();
                const todosPuestos = todosRaw.map((p) => ({
                    puestoId: p.puestoId,
                    nombre: (p.clienteNombre || '') + ' - ' + (p.proyectoNombre || '') + ' - ' + (p.puestoNombre || ''),
                    clienteNombre: p.clienteNombre || '',
                    proyectoNombre: p.proyectoNombre || '',
                    puestoNombre: p.puestoNombre || ''
                }));

                // 2. Obtener puestos asignados al usuario
                const asignados = await obtenerPuestosDeUsuario(usuarioSel.usuarioId);
                const idsAsignados = new Set(asignados.map((p) => p.puestoId));

                // 3. Separar en origen (disponibles) y destino (asignados)
                const asignadosConNombre = todosPuestos.filter((p) => idsAsignados.has(p.puestoId));
                const disponibles = todosPuestos.filter((p) => !idsAsignados.has(p.puestoId));

                setOrigen(disponibles);
                setDestino(asignadosConNombre);
            } catch (err) {
                console.error('Error cargando puestos:', err?.response?.status, err?.response?.data, err.message);
            } finally {
                setCargandoPuestos(false);
            }
        };
        carga();
    }, [usuarioSel]);

    const onChange = (event) => {
        setOrigen(event.source);
        setDestino(event.target);
    };

    const itemTemplate = (item) => (
        <div className="flex flex-column p-1">
            <span className="font-bold text-sm">{item.puestoNombre}</span>
            <small className="text-500">{item.clienteNombre} - {item.proyectoNombre}</small>
        </div>
    );

    const handleGuardar = async () => {
        if (!usuarioSel?.usuarioId) return;
        try {
            setProcesando(true);
            const datosPost = destino.map((item) => ({
                puestoId: item.puestoId,
                usuarioIds: []
            }));
            await guardarPuestosDeUsuario(usuarioSel.usuarioId, datosPost);
            toast?.current?.show({
                severity: 'success',
                summary: 'Exito',
                detail: 'Puestos asignados correctamente al usuario ' + usuarioSel.username
            });
        } catch (err) {
            console.error('Error guardando', err);
            toast?.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al asignar puestos'
            });
        } finally {
            setProcesando(false);
        }
    };

    return (
        <div className="card">
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-3">
                    <label className="font-bold">Usuario:</label>
                </div>
                <div className="field col-12 md:col-9">
                    <Dropdown
                        options={lstUsuarios}
                        value={usuarioSel}
                        onChange={(e) => setUsuarioSel(e.value)}
                        optionLabel="username"
                        placeholder="Seleccione un usuario"
                        filter
                        showClear
                        loading={cargandoUsuarios}
                        itemTemplate={(option) => (
                            <div>
                                <span className="font-bold">{option.username}</span>
                                <small className="text-500 ml-2">{option.nombre}</small>
                            </div>
                        )}
                        valueTemplate={(option, props) => {
                            if (option) {
                                return <span>{option.username} - {option.nombre}</span>;
                            }
                            return <span>{props.placeholder}</span>;
                        }}
                        dataKey="usuarioId"
                    />
                </div>

                <div className="field col-12">
                    <BlockUI
                        blocked={cargandoPuestos}
                        template={<ProgressSpinner style={{ width: '50px', height: '50px' }} />}
                    >
                        {usuarioSel ? (
                            <PickList
                                source={origen}
                                target={destino}
                                onChange={onChange}
                                dataKey="puestoId"
                                itemTemplate={itemTemplate}
                                sourceHeader="Puestos Disponibles"
                                targetHeader="Puestos Asignados"
                                showSourceFilter
                                showTargetFilter
                                sourceFilterPlaceholder="Buscar puesto..."
                                targetFilterPlaceholder="Buscar puesto..."
                                filterBy="nombre"
                                showSourceControls={false}
                                showTargetControls={false}
                                breakpoint="1000px"
                            />
                        ) : (
                            <div className="text-center text-500 p-5">
                                <i className="pi pi-user text-400 mb-3" style={{ fontSize: '3rem' }}></i>
                                <p>Seleccione un usuario para ver sus puestos asignados</p>
                            </div>
                        )}
                    </BlockUI>
                </div>

                <div className="field col-12 md:col-9">
                    <label style={{ visibility: 'hidden' }}>-</label>
                </div>
                <div className="field col-12 md:col-3">
                    <Button
                        icon="pi pi-save"
                        label="Guardar"
                        onClick={handleGuardar}
                        loading={procesando}
                        disabled={!usuarioSel}
                    />
                </div>
            </div>
        </div>
    );
};

export default AsignaPuestosUsuario;
